export default "__VITE_ASSET__BAR0tQCG__"